import React from "react";
import {
  CardBody,
  Card,
  Label,
  Col,
  Button,
  Row,
  CardGroup,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import Select from "react-select";
import { getUserInfo } from "../../../../helper";
import {
  downloadEWSReportRequest,
  ewsPublishListRequest,
  fetchCorporateEwsRequest,
} from "../action";
import fileSaver from "file-saver";
import { toast } from "react-toastify";
import { Preloading as preloading } from "../../../../components/UI/Preloader/action";
import "./ews.scss";

import {
  GST,
  EPF,
  LEGAL,
  RATING,
  MCA,
  EXTERNAL_CREDIT_RATING,
  CRAWLER_COM_SCORE_GREATER_THAN_75,
  EXTERNAL_RATING_SCORE_GREATER_THAN_75,
  GREATER_THAN_OR_EQUAL_TO_50,
  LESS_THAN_50,
  SCORE_NOTE_FOR_LEGAL,
  SHORT_TERM_NOTE_FOR_RATING,
  LONG_TERM_NOTE_FOR_RATING,
  SCORE_NOTE_FOR_RATING,
  BALANCE_SHEET_NOTE_FOR_MCA,
  COMPANY_COMPLIANCE_NOTE_FOR_MCA,
  COMPANY_STATUS_NOTE_FOR_MCA,
  SCORE_NOTE_FOR_MCA,
  CURRENT_DELAY_NOTE_FOR_EPF,
  SCORE_NOTE_FOR_EPF,
  AVERAGE_DELAY_NOTE_FOR_EPF,
  CURRENT_DELAY_NOTE_FOR_GST,
  SCORE_NOTE_FOR_GST,
  AVERAGE_DELAY_NOTE_FOR_GST,
  NOT_APPLICABLE,
  SUPREME_COURT_NOTE_FOR_LEGAL,
  HIGH_COURT_NOTE_FOR_LEGAL,
  DEFAULTERS_NOTE_FOR_LEGAL,
  TRIBUNALS_COURT_NOTE_FOR_LEGAL,
  IBC_NOTE_FOR_LEGAL,
} from "../../constants";
import {
  crawlerDataOptions,
  prepareLegalCourtCasesGraphData,
  prepareLegalCourtCasesData,
  prepareCompanyBalanceSheetDateGraphData,
  prepareCompanyBalanceSheetDateData,
  getScoreFromObj,
  prepareDelayData,
  prepareScoreData,
  prepareComapnyComplianceData,
  prepareCompanyComplianceGraphData,
  prepareCompanyStatusGraphData,
  prepareCompanyStatusData,
  prepareDelayGraphData,
  prepareLongTermRatingData,
  prepareGraphData,
} from "../charts/monitoring-util";

import MonitoringPieChart from "../charts/monitoring-pie-chart";
import MonitoringBarChart from "../charts/monitoring-bar-chart";

import MonitoringPieChartEPFGST from "../charts/monitoring-pie-chart-gst-epf";
import MonitoringScorePieChart from "../charts/monitoring-score-pie-chart";
import MonitoringStatusPieChart from "../charts/monitoring-mca-pie-chart";
import MonitoringRatingStatusPieChart from "../charts/monitoring-rating-status-pie-chart";
import MonitoringCommplaincesPieChart from "../charts/monitoring-mca-compliance-pie-chart";
import MonitoringLegalCourtCasesPieChart from "../charts/monitoring-legal-court-cases-pie-chart";

export const scoreData1 = Object.freeze({
  GREATER_THAN_OR_EQUAL_TO_50: 0,
  LESS_THAN_50: 0,
  CRAWLER_COM_SCORE_GREATER_THAN_75: 0,
  NOT_APPLICABLE_OR_AVAILABLE: 0,
});
export const avgDelayData1 = Object.freeze({
  _1_TO_7_DAYS: 0,
  _8_TO_15_DAYS: 0,
  _16_TO_30_DAYS: 0,
  _31_TO_60_DAYS: 0,
  _61_TO_90_DAYS: 0,
  _MORE_THAN_90_DAYS: 0,
  _NO_DELAY: 0,
  _NA: 0,
});
export const currentDelayData1 = Object.freeze({
  _1_TO_7_DAYS: 0,
  _8_TO_15_DAYS: 0,
  _16_TO_30_DAYS: 0,
  _31_TO_60_DAYS: 0,
  _61_TO_90_DAYS: 0,
  _MORE_THAN_90_DAYS: 0,
  _NO_DELAY: 0,
  _NA: 0,
});
export const companyStatusData1 = Object.freeze({
  NOT_APPLICABLE: 0,
  COMPANY_STATUS_ACTIVE: 0,
  COMPANY_STATUS_INACTIVE: 0,
  DORMANT: 0,
  DORMANT_UNDER_SECTION_455: 0,
  ACTIVE_IN_PROGRESS: 0,
  AMALGAMATED: 0,
  NOT_AVAILABLE_FOR_EFILING: 0,
  CONVERTED_TO_LLP: 0,
  CONVERTED_TO_LLP_DISSOLVED: 0,
  DISSOLVED: 0,
  UNDER_LIQUIDATION: 0,
  LIQUIDATED: 0,
  UNDER_PROCESS_OF_STRIKING_OFF: 0,
  STRIKE_OFF: 0,
  CAPTURED: 0,
});
export const comapnyComplianceData1 = Object.freeze({
  COMPANY_COMPLIANCE_ACTIVE: 0,
  COMPANY_NON_COMPLIANCE_ACTIVE: 0,
  _NA: 0,
});
export const legalData1 = Object.freeze({ No: 0, Yes: 0 });
export const legalCourtCasesData1 = Object.freeze({
  _0_CASES: 0,
  _1_TO_3_CASES: 0,
  _4_TO_10_CASES: 0,
  _MORE_THAN_10_CASES: 0,
});
export const longTermRating1 = Object.freeze({
  AAA: 0,
  AA: 0,
  A: 0,
  BBB: 0,
  BB: 0,
  B: 0,
  C: 0,
  D: 0,
  "Issuer Not Cooperating": 0,
  "Not Applicable": 0,
});
export const shortTermRating1 = Object.freeze({
  A1: 0,
  A2: 0,
  A3: 0,
  A4: 0,
  D: 0,
  "Issuer Not Cooperating": 0,
  "Not Applicable": 0,
});
export const ratingStatusData1 = Object.freeze({
  NOT_RATED: 0,
  NA: 0,
  DOWNGRADED: 0,
  ISSUER_NOT_COOPERATING: 0,
  NEWLY_RATED: 0,
  UPGRADED: 0,
  NO_CHANGE: 0,
});
export const scoreLegendGST = "GST Compliance Score ";
export const scoreLegendEPF = "EPF Compliance Score ";
export const scoreLegendMCA = "MCA Compliance Score";
export const scoreLegendRating = "External Credit Rating Score ";
export const scoreLegendLegal = "Legal Compliance Score";

const portfolioOptions = [
  { value: "Portfolio", label: "Portfolio" },
  { value: "Non Portfolio", label: "Non Portfolio" },
];



class EWSChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      portfolioSelectedOption: { value: "Portfolio", label: "Portfolio" },
      isPortfolio: undefined,
      selectedPublish: null,
      publishList: [],
      crawlerSelectedOption: { value: GST, label: "GST" },
      crawlerDataOptions: [],
      scoreData: {},
      scoreGraphData: [],
      avgDelayData: {},
      avgDelayGraphData: [],
      currentDelayData: {},
      currentDelayGraphData: {},
      companyStatusData: {},
      companyStatusGraphData: [],
      comapnyComplianceData: {},
      comapnyComplianceGraphData: [],
      companyBalanceSheetDateData: {},
      companyBalanceSheetDateGraphData: [],
      legalDefaultersData: {},
      legalDefaultersGraphData: [],
      legalSupremeCourtData: {},
      legalSupremeCourtGraphData: [],
      legalHighCourtData: {},
      legalHighCourtGraphData: [],
      legalTribunalsData: {},
      legalTribunalsGraphData: [],
      legalIBCData: {},
      legalIBCGraphData: [],
      longTermData: {},
      longTermGraphData: [],
      shortTermRating: {},
      shortTermRatingGraphData: [],
      SCORE_NOTE: undefined,
      AVERAGE_DELAY_NOTE: undefined,
      CURRENT_DELAY_NOTE: undefined,
      SCORE_LEGEND: undefined,
      CurrentAverageLegend: undefined,
      columns:[
        { Header: "Corporate Name", accessor: "corporateName", },
        { Header: "Counterparty Name", accessor: "counterpartyName", 
        filterMethod: (filter, row) => {
          const id = filter.pivotId || filter.id;
          return row[id] !== undefined
            ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
            : true;
        },
        Filter: ({ filter, onChange }) => (
          <input
            onChange={(event) => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            placeholder="Search..."
          />),
        },
        {
          Header: "Current Rubix Business Check Score After Ews",
          accessor: "currentRubixBusinessCheckScoreAfterEws",
        },
        {
          Header: "Rubix Business Check Score",
          accessor: "rubixBusinessCheckScore",
        },
        { Header: "Change", accessor: "change",},
      ],
      EWStable:null,
      filterTableWithCounterpartyName:null,
      isEWSViewReportButtonClicked:false,
    };
    
  }

  prepareScoreGraphData = (crawler) => {
    switch (crawler) {
      case LEGAL:
        crawler = "Legal";
        break;
      case RATING:
        crawler = EXTERNAL_CREDIT_RATING;
        break;
    }
    let scoreData = [];
    if (crawler == EXTERNAL_CREDIT_RATING) {
      scoreData = [
        ["Range of Score", "Score"],
        [
          crawler + EXTERNAL_RATING_SCORE_GREATER_THAN_75,
          this.state.scoreData[
            crawler + "EXTERNAL_RATING_SCORE_GREATER_THAN_75"
          ],
        ],
        [
          GREATER_THAN_OR_EQUAL_TO_50,
          this.state.scoreData["GREATER_THAN_OR_EQUAL_TO_50"],
        ],
        [LESS_THAN_50, this.state.scoreData["LESS_THAN_50"]],
        [NOT_APPLICABLE, this.state.scoreData["NOT_APPLICABLE_OR_AVAILABLE"]],
      ];
    } else {
      scoreData = [
        ["Range of Score", "Score"],
        [
          crawler + CRAWLER_COM_SCORE_GREATER_THAN_75,
          this.state.scoreData[crawler + "CRAWLER_COM_SCORE_GREATER_THAN_75"],
        ],
        [
          GREATER_THAN_OR_EQUAL_TO_50,
          this.state.scoreData["GREATER_THAN_OR_EQUAL_TO_50"],
        ],
        [LESS_THAN_50, this.state.scoreData["LESS_THAN_50"]],
        [NOT_APPLICABLE, this.state.scoreData["NOT_APPLICABLE_OR_AVAILABLE"]],
      ];
    }
    this.setState({ scoreGraphData: scoreData });
  };

  normalizeGraphData = () => {
    this.prepareScoreGraphData(this.state.crawlerSelectedOption.value);
    if (
      this.state.crawlerSelectedOption &&
      (this.state.crawlerSelectedOption.value === GST ||
        this.state.crawlerSelectedOption.value === EPF)
    ) {
      let avgDelayData = prepareDelayGraphData(
        "Average Delay Days",
        this.state.avgDelayData
      );
      let currentDelayData = prepareDelayGraphData(
        "Current Delay Days",
        this.state.currentDelayData
      );
      if (this.state.crawlerSelectedOption.value === EPF) {
        this.setState({
          SCORE_NOTE: SCORE_NOTE_FOR_EPF,
          AVERAGE_DELAY_NOTE: AVERAGE_DELAY_NOTE_FOR_EPF,
          CURRENT_DELAY_NOTE: CURRENT_DELAY_NOTE_FOR_EPF,
          SCORE_LEGEND: scoreLegendEPF,
          CurrentAverageLegend: this.state.crawlerSelectedOption,
        });
      } else {
        this.setState({
          SCORE_NOTE: SCORE_NOTE_FOR_GST,
          AVERAGE_DELAY_NOTE: AVERAGE_DELAY_NOTE_FOR_GST,
          CURRENT_DELAY_NOTE: CURRENT_DELAY_NOTE_FOR_GST,
          SCORE_LEGEND: scoreLegendGST,
          CurrentAverageLegend: this.state.crawlerSelectedOption,
        });
      }

      this.setState({
        avgDelayGraphData: avgDelayData,
        currentDelayGraphData: currentDelayData,
      });
    } else if (
      this.state.crawlerSelectedOption &&
      this.state.crawlerSelectedOption.value === MCA
    ) {
      let companyStatusGraphData = prepareCompanyStatusGraphData(
        "Company Status",
        this.state.companyStatusData
      );
      let comapnyComplianceGraphData = prepareCompanyComplianceGraphData(
        "Compliance",
        this.state.comapnyComplianceData
      );
      let companyBalanceSheetDateGraphData =
        prepareCompanyBalanceSheetDateGraphData(
          "Balance Sheet",
          this.state.companyBalanceSheetDateData
        );
      this.setState({
        companyStatusGraphData: companyStatusGraphData,
        comapnyComplianceGraphData: comapnyComplianceGraphData,
        companyBalanceSheetDateGraphData: companyBalanceSheetDateGraphData,
        SCORE_NOTE: SCORE_NOTE_FOR_MCA,
        SCORE_LEGEND: scoreLegendMCA,
      });
    } else if (
      this.state.crawlerSelectedOption &&
      this.state.crawlerSelectedOption.value === LEGAL
    ) {
      let legalDefaultersGraphData = prepareLegalCourtCasesGraphData(
        "Defaulters",
        this.state.legalDefaultersData
      );
      let legalSupremeCourtGraphData = prepareLegalCourtCasesGraphData(
        "Supreme Court",
        this.state.legalSupremeCourtData
      );
      let legalHighCourtGraphData = prepareLegalCourtCasesGraphData(
        "High Court",
        this.state.legalHighCourtData
      );
      let legalTribunalsGraphData = prepareLegalCourtCasesGraphData(
        "Tribunals",
        this.state.legalTribunalsData
      );
      let legalIBCGraphData = prepareLegalCourtCasesGraphData(
        "IBC",
        this.state.legalIBCData
      );
      this.setState({
        legalDefaultersGraphData: legalDefaultersGraphData,
        legalSupremeCourtGraphData: legalSupremeCourtGraphData,
        legalHighCourtGraphData: legalHighCourtGraphData,
        legalTribunalsGraphData: legalTribunalsGraphData,
        legalIBCGraphData: legalIBCGraphData,
        SCORE_NOTE: SCORE_NOTE_FOR_LEGAL,
        SCORE_LEGEND: scoreLegendLegal,
      });
    } else if (
      this.state.crawlerSelectedOption &&
      this.state.crawlerSelectedOption.value === RATING
    ) {
      let longTermGraphData = prepareGraphData(this.state.longTermData, "");
      let shortTermRatingGraphData = prepareGraphData(
        this.state.shortTermRating,
        ""
      );
      this.setState({
        longTermGraphData: longTermGraphData,
        shortTermRatingGraphData: shortTermRatingGraphData,
        SCORE_NOTE: SCORE_NOTE_FOR_RATING,
        SCORE_LEGEND: scoreLegendRating,
      });
    }
  };

  prepareGraphData = () => {
    let scoreData = { ...scoreData1 };
    switch (this.state.crawlerSelectedOption.value) {
      case GST:
        scoreData[GST + "CRAWLER_COM_SCORE_GREATER_THAN_75"] =
          scoreData["CRAWLER_COM_SCORE_GREATER_THAN_75"];
        break;
      case MCA:
        scoreData[MCA + "CRAWLER_COM_SCORE_GREATER_THAN_75"] =
          scoreData["CRAWLER_COM_SCORE_GREATER_THAN_75"];
        break;
      case EPF:
        scoreData[EPF + "CRAWLER_COM_SCORE_GREATER_THAN_75"] =
          scoreData["CRAWLER_COM_SCORE_GREATER_THAN_75"];
        break;
      case LEGAL:
        scoreData["Legal" + "CRAWLER_COM_SCORE_GREATER_THAN_75"] =
          scoreData["CRAWLER_COM_SCORE_GREATER_THAN_75"];
        break;
      case RATING:
        scoreData[
          EXTERNAL_CREDIT_RATING + "EXTERNAL_RATING_SCORE_GREATER_THAN_75"
        ] = scoreData["CRAWLER_COM_SCORE_GREATER_THAN_75"];
        break;
    }
    let companyStatusData = { ...companyStatusData1 };
    let avgDelayData = { ...avgDelayData1 };
    let currentDelayData = { ...currentDelayData1 };
    let comapnyComplianceData = { ...comapnyComplianceData1 };
    let companyBalanceSheetDateData = { NA: 0 };
    let legalSupremeCourtData = { ...legalCourtCasesData1 };
    let legalHighCourtData = { ...legalCourtCasesData1 };
    let legalDefaultersData = { ...legalCourtCasesData1 };
    let legalTribunalsData = { ...legalCourtCasesData1 };
    let legalIBCData = { ...legalCourtCasesData1 };
    let longTermData = { ...longTermRating1 };
    let shortTermRating = { ...shortTermRating1 };
    if (
      this.props.corporateMonitoringData &&
      this.props.corporateMonitoringData.length > 0
    ) {
      this.props.corporateMonitoringData.forEach((obj) => {
        let score = getScoreFromObj(
          obj,
          this.state.crawlerSelectedOption.value
        );
        scoreData = prepareScoreData(
          scoreData,
          score,
          this.state.crawlerSelectedOption.value
        );
        if (
          this.state.crawlerSelectedOption &&
          (this.state.crawlerSelectedOption.value === GST ||
            this.state.crawlerSelectedOption.value === EPF)
        ) {
          avgDelayData = prepareDelayData(avgDelayData, obj.avgDelay);
          currentDelayData = prepareDelayData(
            currentDelayData,
            obj.currentDelay
          );
        } else if (
          this.state.crawlerSelectedOption &&
          this.state.crawlerSelectedOption.value === MCA
        ) {
          companyStatusData = prepareCompanyStatusData(
            companyStatusData,
            obj.companyStatus
          );
          comapnyComplianceData = prepareComapnyComplianceData(
            comapnyComplianceData,
            obj.activeCompliance
          );
          companyBalanceSheetDateData = prepareCompanyBalanceSheetDateData(
            companyBalanceSheetDateData,
            obj.yearOfLatestBalanceSheet
          );
        } else if (
          this.state.crawlerSelectedOption &&
          this.state.crawlerSelectedOption.value === LEGAL
        ) {
          legalSupremeCourtData = prepareLegalCourtCasesData(
            legalSupremeCourtData,
            obj.supremeCourtRespondent
          );
          legalHighCourtData = prepareLegalCourtCasesData(
            legalHighCourtData,
            obj.highCourtRespondent
          );
          legalDefaultersData = prepareLegalCourtCasesData(
            legalDefaultersData,
            obj.defaultersRespondent
          );
          legalTribunalsData = prepareLegalCourtCasesData(
            legalTribunalsData,
            obj.tribunalsRespondent
          );
          legalIBCData = prepareLegalCourtCasesData(
            legalIBCData,
            obj.ibcRespondent
          );
        } else if (
          this.state.crawlerSelectedOption &&
          this.state.crawlerSelectedOption.value === RATING
        ) {
          longTermData = prepareLongTermRatingData(
            longTermData,
            obj.longTermCurrentRating,
            obj.longTermStatus
          );
          shortTermRating = prepareLongTermRatingData(
            shortTermRating,
            obj.shortTermCurrentRating,
            obj.shortTermStatus
          );
        }
      });
      this.setState(
        {
          scoreData: scoreData,
          avgDelayData: avgDelayData,
          currentDelayData: currentDelayData,
          companyStatusData: companyStatusData,
          comapnyComplianceData: comapnyComplianceData,
          companyBalanceSheetDateData: companyBalanceSheetDateData,
          legalDefaultersData: legalDefaultersData,
          legalSupremeCourtData: legalSupremeCourtData,
          legalHighCourtData: legalHighCourtData,
          legalTribunalsData: legalTribunalsData,
          legalIBCData: legalIBCData,
          longTermData: longTermData,
          shortTermRating: shortTermRating,
        },
        () => {
          this.normalizeGraphData();
        }
      );
    }
  };

  fetchCorporateEwsData = (e) => {
    e.preventDefault();
    this.setState({isEWSViewReportButtonClicked: false})
    if (this.state.selectedPublish && this.state.selectedPublish.value) {
      this.props.preloading(true);
      this.props.fetchCorporateEwsRequest({
        type: this.state.crawlerSelectedOption.value,
        corporateId: this.state.userData
          ? this.state.userData.corporateId
          : undefined,
        publishId: this.state.selectedPublish.value,
        isPortfolio:
          this.state.portfolioSelectedOption.value === "Portfolio"
            ? true
            : false,
      });
    }
  };

  componentDidMount() {
    let data = getUserInfo();
    this.setState({ userData: data });
    this.props.ewsPublishListRequest({ corporateId: data.corporateId });
    this.props.preloading(true);
    this.setState({ crawlerDataOptions: crawlerDataOptions });
  }

  handleCrawlerChange = (option) => {
    this.setState({ crawlerSelectedOption: option });
  };

  componentDidUpdate(prevProps) {
    if (this.props.corporateEWSReport !== prevProps.corporateEWSReport) {
      this.props.preloading(false);
      if (this.props.corporateEWSReport.status === "SUCCESS") {
        let statusCode = this.props.corporateEWSReport.data["status"];
        if (statusCode === 200) {
          const data = this.props.corporateEWSReport.data.data;
          let blob = new Blob([data], { type: "application/octet-stream" });
          fileSaver.saveAs(
            blob,
            `${
              this.state.selectedPublish.label +
              (this.state.isPortfolio ? "_Portfolio" : "_Non_Portfolio")
            }_${moment().format("DD_MMM_YYYY")}.xlsx`
          );
        } else if (statusCode === 204) {
          toast.error(
            <div>
              <i className="fa fa-exclamation-triangle"></i> No data Available
              !!
            </div>
          );
        }
      } else if (this.props.corporateEWSReport.status === "FAILURE") {
        toast.error(
          <div>
            <i className="fa fa-exclamation-triangle"></i> Please Try again !!
          </div>
        );
      }
    }

    if (this.props.publishList != prevProps.publishList) {
      this.props.preloading(false);
      let publishes = [];

      if (this.props.publishList.data != "") {
        this.props.publishList.data.forEach((item) => {
          publishes.push({ value: item.id, label: item.publishName });
        });
      }

      this.setState(
        {
          publishList: publishes,
          publishSelectedOption:
            publishes.length > 0 ? publishes[0] : undefined,
        },
        () => {
          if (
            this.state.publishSelectedOption &&
            this.state.publishSelectedOption.value
          ) {
            this.props.preloading(true);
            this.props.fetchCorporateEwsRequest({
              type: this.state.crawlerSelectedOption.value,
              corporateId: this.state.userData
                ? this.state.userData.corporateId
                : undefined,
              publishId: this.state.publishSelectedOption.value,
              isPortfolio:
                this.state.portfolioSelectedOption.value === "Portfolio"
                  ? true
                  : false,
            });
          }
        }
      );
    }

    if (
      prevProps.corporateMonitoringData !== this.props.corporateMonitoringData
    ) {
      this.props.preloading(false);
      this.setState({
        avgDelayData: {},
        currentDelayData: {},
        scoreData: {},
        companyStatusData: {},
        companyStatusGraphData: {},
        companyBalanceSheetDateData: {},
        legalDefaultersData: {},
        legalSupremeCourtData: {},
        legalHighCourtData: {},
        legalTribunalsData: {},
        legalIBCData: {},
        longTermData: {},
        shortTermRating: {},
        shortTermStatus: {},
        longTermStatus: {},
        scoreGraphData: [],
        avgDelayGraphData: [],
        currentDelayGraphData: [],
        companyStatusGraphData: [],
        comapnyComplianceGraphData: [],
        companyBalanceSheetDateGraphData: [],
        legalDefaultersGraphData: [],
        legalSupremeCourtGraphData: [],
        legalHighCourtGraphData: [],
        legalTribunalsGraphData: [],
        legalIBCGraphData: [],
        longTermGraphData: [],
        shortTermRatingGraphData: [],
        shortTermStatusGraphData: [],
        longTermStatusGraphData: [],
      });
      this.prepareGraphData();
    }
  }

  downloadEWSReport = (e) => {
    e.preventDefault();
    this.props.preloading(true);
    var selectedPublishMetadata = this.props.publishList.data.find((obj) => {
      return obj.id === this.state.selectedPublish.value;
    });
    this.props.downloadEWSReportRequest({
      corporateId: this.state.userData
        ? this.state.userData.corporateId
        : undefined,
      publishId: this.state.selectedPublish.value,
      fromDate: selectedPublishMetadata.fromDate,
      isPortfolio:
        this.state.portfolioSelectedOption.value === "Portfolio" ? true : false,
    });
  };

  handlePortfolioChange = (data) => {
    this.setState({
      portfolioSelectedOption: data,
    });
  };

  handlePublishChange = (data) => {
    this.setState({
      selectedPublish: data,
    });
  };

  render() {
    return (
      <Col>
        <div>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Label><h3>EWS Graph</h3></Label>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <Select
                    placeholder={"Select Publish Name"}
                    defaultValue={this.state.selectedPublish}
                    value={this.state.selectedPublish}
                    onChange={this.handlePublishChange}
                    options={this.state.publishList}
                  />
                </Col>
                <Col sm={4}>
                  <Select
                    defaultValue={this.state.portfolioSelectedOption}
                    value={this.state.portfolioSelectedOption}
                    onChange={this.handlePortfolioChange}
                    options={portfolioOptions}
                  />
                </Col>
                <Col sm={4}>
                  <Select
                    value={this.state.crawlerSelectedOption}
                    onChange={this.handleCrawlerChange}
                    options={this.state.crawlerDataOptions}
                  />
                </Col>
                <Col sm={3}>
                  <Button
                    disabled={!this.state.selectedPublish}
                    color="primary"
                    onClick={(e) => this.fetchCorporateEwsData(e)}
                  >
                    <i></i> Show Graph
                  </Button>
                </Col>
                <Col sm={4}>
                  <Button
                    disabled={!this.state.selectedPublish}
                    color="primary"
                    onClick={(e) => this.downloadEWSReport(e)}
                  >
                    <i className="fa fa-download"></i> Download Report
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <br></br>
          {this.state.isEWSViewReportButtonClicked && this.state.EWStable && <input className="ewsViewFormSerach"
        type="text"
        onChange={(e) => this.setTableFilter(e.target.value)}
        placeholder="Search By Counterparty Name..."
      />}
          {this.state.isEWSViewReportButtonClicked && this.state.EWStable && this.state.EWStable}
          
          <CardGroup style={{ justifyContent: "center" }}>
            {this.state.scoreGraphData &&
              this.state.scoreGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringScorePieChart
                    data={this.state.scoreGraphData}
                    title={this.state.SCORE_LEGEND}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.state.SCORE_NOTE,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}

            {this.state.avgDelayGraphData &&
              this.state.avgDelayGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringPieChartEPFGST
                    data={this.state.avgDelayGraphData}
                    title={
                      "Average Days of Delay in filing " +
                      this.state.CurrentAverageLegend.value +
                      " Returns"
                    }
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.state.AVERAGE_DELAY_NOTE,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.currentDelayGraphData &&
              this.state.currentDelayGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringPieChartEPFGST
                    data={this.state.currentDelayGraphData}
                    title={
                      "Current Days of Delay in filing " +
                      this.state.CurrentAverageLegend.value +
                      " Returns"
                    }
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: this.state.CURRENT_DELAY_NOTE,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}

            {this.state.companyStatusGraphData &&
              this.state.companyStatusGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringStatusPieChart
                    data={this.state.companyStatusGraphData}
                    title={"Company Status"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: COMPANY_STATUS_NOTE_FOR_MCA,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.comapnyComplianceGraphData &&
              this.state.comapnyComplianceGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringCommplaincesPieChart
                    data={this.state.comapnyComplianceGraphData}
                    title={"MCA Compliance"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: COMPANY_COMPLIANCE_NOTE_FOR_MCA,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.companyBalanceSheetDateGraphData &&
              this.state.companyBalanceSheetDateGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringBarChart
                    data={this.state.companyBalanceSheetDateGraphData}
                    title={"Latest Year of Financial Statements"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: BALANCE_SHEET_NOTE_FOR_MCA,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}

            {this.state.legalSupremeCourtGraphData &&
              this.state.legalSupremeCourtGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringLegalCourtCasesPieChart
                    data={this.state.legalSupremeCourtGraphData}
                    title={"Supreme Court Cases"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: SUPREME_COURT_NOTE_FOR_LEGAL,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.legalHighCourtGraphData &&
              this.state.legalHighCourtGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringLegalCourtCasesPieChart
                    data={this.state.legalHighCourtGraphData}
                    title={"High Court Cases"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: HIGH_COURT_NOTE_FOR_LEGAL,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.legalDefaultersGraphData &&
              this.state.legalDefaultersGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringLegalCourtCasesPieChart
                    data={this.state.legalDefaultersGraphData}
                    title={"Defaulters Cases"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: DEFAULTERS_NOTE_FOR_LEGAL,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.legalTribunalsGraphData &&
              this.state.legalTribunalsGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringLegalCourtCasesPieChart
                    data={this.state.legalTribunalsGraphData}
                    title={"Tribunals Cases"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: TRIBUNALS_COURT_NOTE_FOR_LEGAL,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.legalIBCGraphData &&
              this.state.legalIBCGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringLegalCourtCasesPieChart
                    data={this.state.legalIBCGraphData}
                    title={"Insolvency and Bankruptcy Code (IBC) Cases"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{ __html: IBC_NOTE_FOR_LEGAL }}
                    ></p>
                                                
                  </details>
                </Card>
              )}

            {this.state.longTermGraphData &&
              this.state.longTermGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringBarChart
                    data={this.state.longTermGraphData}
                    title={"Distribution of Long-Term External Credit Ratings"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: LONG_TERM_NOTE_FOR_RATING,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
            {this.state.shortTermRatingGraphData &&
              this.state.shortTermRatingGraphData.length > 0 && (
                <Card style={{ minWidth: "500px", minHeight: "300px" }}>
                  <MonitoringBarChart
                    data={this.state.shortTermRatingGraphData}
                    title={"Distribution of Short-Term External Credit Ratings"}
                  />
                  <details>
                                                    
                    <summary>
                                                          <i>Know more...</i>
                                                      
                    </summary>
                                                    
                    <p
                      dangerouslySetInnerHTML={{
                        __html: SHORT_TERM_NOTE_FOR_RATING,
                      }}
                    ></p>
                                                
                  </details>
                </Card>
              )}
          </CardGroup>
        </div>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  corporateEWSReport: state.monitoringData.corporateEWSReport,
  corporateMonitoringData: state.monitoringData.corporateMonitoringData,
  publishList: state.monitoringData.publishList,
});

const mapDispatchToProps = (dispatch) => ({
  preloading: (data) => {
    dispatch(preloading(data));
  },
  downloadEWSReportRequest: (data) => {
    dispatch(downloadEWSReportRequest(data));
  },
  ewsPublishListRequest: (data) => {
    dispatch(ewsPublishListRequest(data));
  },
  fetchCorporateEwsRequest: (data) => {
    dispatch(fetchCorporateEwsRequest(data));
  },
});
export default 
  connect(mapStateToProps, mapDispatchToProps)(EWSChart);
